import React from 'react';
import { Text, Button, Icon, Left, Body, Right, ListItem, View } from 'native-base';
import { StyleSheet } from 'react-native';

export default function SelItem({ text, icon, colour, rText, rSubText, subText, onPress, rightIcon = 'arrow-forward' }) {
	return (
		<ListItem icon={!!icon} style={{ marginHorizontal: 10 }} onPress={onPress}>
			<Left>
				{!!icon && (
					<Button style={{ backgroundColor: colour }}>
						<Icon name={icon} />
					</Button>
				)}
			</Left>
			<Body>
				<Text>{text}</Text>
				{!!subText && <Text note>{subText}</Text>}
			</Body>
			<Right>
				{rText && (
					<View style={{ flexDirection: 'column' }}>
						<Text style={styles.rightText}>{rText}</Text>
						<Text small style={styles.rightTextSmall}>
							{rSubText}
						</Text>
					</View>
				)}
				{rightIcon && <Icon name={rightIcon} />}
			</Right>
		</ListItem>
	);
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	},
	rightText: {
		textAlign: 'right',
		fontSize: 14
	},
	rightTextSmall: {
		textAlign: 'right',
		fontSize: 11
	},
	white: { color: '#FFF' },
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		height: 'auto',
		justifyContent: 'center'
	}
});
